<template>
    <div class="container pt-3 pb-3">
        <div class="row">

            <div class="col-lg-4 col-xl-3 py-3" v-if="user.is_profile_completed">
                <div class="card profile-card mx-auto">
                    <div class="card-body">
                        <form enctype="multipart/form-data" novalidate>
                            <h3 class="card-title text-centerpt-2 pb-3 text-center">Profielfoto</h3>
                            <div class="profile-picture text-center mb-4">
                                <img :src="newProfilePictureUrl || profilePicture || '//placehold.it/150'"
                                     width="150" height="150" class="avatar rounded-circle" alt="avatar">
                            </div>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="profile_picture" name="profile_picture"
                                       accept="image/*"
                                       @change="imageUpload" :disabled="profileButtonLoader">
                                <label class="custom-file-label" for="profile_picture">Choose file</label>
                            </div>
                            <error-ele v-if="formValidationErrors && formValidationErrors['profile_picture']"
                                       :errors="formValidationErrors['profile_picture']"/>
                        </form>
                    </div>
                </div>
            </div>

            <div v-if="user.is_profile_completed" class="col-lg-8 col-xl-9 py-3">
                <alert-ele v-show="messageText" :message="messageText" :status="messageStatus" @dismiss="()=>this.messageStatus = null"/>
                <div class="card profile-form">
                    <div class="card-header pb-3">{{ lang.app.profile.title }}</div>
                    <div class="card-body">
                        <div class="border rounded px-4 py-2 mt-2">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="first_name"
                                               class=" col-form-label text-md-right">{{ lang.app.global.first_name
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="first_name" type="text"
                                                    class="form-control"
                                                    name="first_name"
                                                    v-model="form.first_name"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.global.first_name"
                                            >

                                        </div>
                                        <error-ele v-if="formValidationErrors && formValidationErrors['first_name']"
                                                   :errors="formValidationErrors['first_name']"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="last_name"
                                               class=" col-form-label text-md-right">{{ lang.app.global.last_name
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="last_name" type="text"
                                                    class="form-control"
                                                    name="last_name"
                                                    v-model="form.last_name"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.global.last_name"
                                            >

                                        </div>
                                        <error-ele v-if="formValidationErrors && formValidationErrors['last_name']"
                                                   :errors="formValidationErrors['last_name']"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="email"
                                               class=" col-form-label text-md-right">{{ lang.app.global.email }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="email" type="email"
                                                    class="form-control"
                                                    :class="{ 'is-invalid' :  formValidationErrors && formValidationErrors['email'] } "
                                                    name="email"
                                                    v-model="form.email"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.global.email"
                                            >

                                        </div>
                                        <error-ele v-if="formValidationErrors && formValidationErrors['email']"
                                                   :errors="formValidationErrors['email']"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="telephone"
                                               class=" col-form-label text-md-right">{{ lang.app.global.telephone
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="telephone" type="text"
                                                    class="form-control"
                                                    :class="{ 'is-invalid' :  formValidationErrors && formValidationErrors['telephone'] } "
                                                    name="telephone"
                                                    v-model="form.telephone"
                                                    required
                                                    :placeholder="lang.app.global.telephone"
                                            >

                                        </div>
                                        <error-ele v-if="formValidationErrors && formValidationErrors['telephone']"
                                                   :errors="formValidationErrors['telephone']"/>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="user.role === 'farmer'">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="email"
                                               class=" col-form-label text-md-right">{{ lang.app.global.company_name
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="company_name" type="text"
                                                    class="form-control"
                                                    name="company_name"
                                                    v-model="form.farmer.company_name"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.global.company_name"
                                            >

                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&  formValidationErrors['farmer.company_name']"
                                                :errors="formValidationErrors['farmer.company_name']"/>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="vat_number"
                                               class=" col-form-label text-md-right">{{
                                            lang.app.profile.btw_kvk_vat_number
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="vat_number" type="text"
                                                    class="form-control"
                                                    name="vat_number"
                                                    v-model="form.farmer.vat_number"
                                                    required
                                                    maxlength="14"
                                                    :placeholder="(selectedCountry ? lang.app.profile['btw_example_' + selectedCountry.toLowerCase()] : lang.app.profile.btw_kvk_vat_number) + (user.farmer.is_professional ? '' : ' (Niet verplicht)')"
                                            >

                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&    formValidationErrors['farmer.vat_number']"
                                                :errors="formValidationErrors['farmer.vat_number']"/>
                                    </div>
                                </div>
                            </div>
                            <template v-if="user.role == 'advisor'">
                                <div class="row">
                                    <div class="col-md-6 form-group">
                                        <label for="vat_number"
                                               class="col-form-label text-md-right">{{
                                            lang.app.profile.btw_kvk_vat_number
                                            }}</label>
                                        <input
                                                id="advisor_vat_number" type="text"
                                                class="form-control"
                                                name="vat_number"
                                                v-model="form.advisor.vat_number"
                                                required
                                                maxlength="14"
                                                :placeholder="'Niet verplicht'"
                                        >
                                        <error-ele
                                                v-if="formValidationErrors &&    formValidationErrors['advisor.vat_number']"
                                                :errors="formValidationErrors['advisor.vat_number']"/>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <!--<hr>-->
                        <div class="form-group text-center my-4">
                            <button-loader
                                    :isLoading="passwordResetButtonLoader"
                                    :disabled="passwordResetButtonLoader || adminMode"
                                    :classes="'btn btn-black background-' + this.product +' px-md-4'"
                                    @click="passwordReset"
                            > {{ lang.app.reset_password.user_profile_reset_password_button }}
                            </button-loader>
                        </div>

                        <div class="border rounded px-4 py-2 mt-4">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="form-group">
                                        <label for="street_name"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.street_name
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="street_name" type="text"
                                                    class="form-control"
                                                    name="street_name"
                                                    v-model="form.address.street_name"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.profile.street_name"
                                            >
                                        </div>
                                        <error-ele v-if="formValidationErrors &&
                                             formValidationErrors['address.street_name']"
                                                   :errors="formValidationErrors['address.street_name']"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="street_number"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.street_number
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="street_number" type="text"
                                                    class="form-control"
                                                    name="street_number"
                                                    v-model="form.address.street_number"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.profile.street_number"
                                                    maxlength="16"
                                            >

                                        </div>
                                        <error-ele v-if="formValidationErrors &&

                                        formValidationErrors['address.street_number']"
                                                   :errors="formValidationErrors['address.street_number']"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="country"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.country
                                            }}</label>
                                        <div class="input-group">
                                            <select
                                                    id="country"
                                                    class="form-control"
                                                    name="country"
                                                    required
                                                    autocomplete="none"
                                                    @change="toggleShowAllCountries"
                                                    :placeholder="lang.app.profile.country"
                                            >
                                                <option value="">{{ lang.app.profile.select }}</option>
                                                <template v-for="country in countries" v-if="showAllCountries || ['BE', 'NL', form.address.country].indexOf(country.value) > -1">
                                                    <option :value="country.value" :selected="form.address.country === country.value">
                                                        {{ country.label }}
                                                    </option>
                                                </template>
                                                <option value="more" v-if="!showAllCountries">More...</option>
                                            </select>

                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&
                                                formValidationErrors['address.country']"
                                                :errors="formValidationErrors['address.country']"/>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="postal_code"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.postal_code
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="postal_code" type="text"
                                                    class="form-control"
                                                    name="postal_code"
                                                    v-model="form.address.postal_code"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.profile.postal_code"
                                            >
                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&
                                                formValidationErrors['address.postal_code']"
                                                :errors="formValidationErrors['address.postal_code']"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="city"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.city }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="city" type="text"
                                                    class="form-control"
                                                    name="city"
                                                    v-model="form.address.city"
                                                    required
                                                    autocomplete="none"
                                                    :placeholder="lang.app.profile.city"
                                            >
                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&
                                                formValidationErrors['address.city']"
                                                :errors="formValidationErrors['address.city']"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--<hr v-if="user.role ===  'farmer'">-->
                        <div class="border rounded px-4 py-2 mt-4" v-if="user.role === 'farmer' && ['NL', 'BE'].indexOf(selectedCountry) !== -1">
                            <div class="row">
                                <div class="col-md-6" v-if="selectedCountry==='NL'">
                                    <div class="form-group">
                                        <label for="ubn_number"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.ubn_number
                                            }}</label>
                                        <div class="input-group">
                                            <input
                                                    id="ubn_number" type="text"
                                                    class="form-control"
                                                    name="ubn_number"
                                                    v-model="form.farmer.ubn_number"
                                                    required
                                                    :disabled="this.user.farmer.ubn_number && this.user.farmer.ubn_number.trim().length > 0"
                                                    autocomplete="none"
                                                    :placeholder="lang.app.profile.ubn_number"
                                            >
                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&   formValidationErrors['farmer.ubn_number']"
                                                :errors="formValidationErrors['farmer.ubn_number']"/>

                                    </div>
                                </div>
                                <div class="col-md-6" v-if="selectedCountry==='BE'">
                                    <div class="form-group">
                                        <label for="exploitation_number"
                                               class=" col-form-label text-md-right">{{ lang.app.profile.exploitation_number}}</label>
                                        <div class="input-group">
                                            <input
                                                    id="exploitation_number" type="text"
                                                    class="form-control"
                                                    name="exploitation_number"
                                                    v-model="form.farmer.exploitation_number"
                                                    required
                                                    :disabled="this.user.farmer.exploitation_number && this.user.farmer.exploitation_number.trim().length > 0"
                                                    autocomplete="none"
                                                    :placeholder="lang.app.profile.exploitation_number_placeholder"
                                            >
                                        </div>
                                        <error-ele
                                                v-if="formValidationErrors &&  formValidationErrors['farmer.exploitation_number']"
                                                :errors="formValidationErrors['farmer.exploitation_number']"/>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group mb-2">
                        <div>
                            <button-loader
                                    :isLoading="profileButtonLoader"
                                    :disabled="profileButtonLoader || disableSave"
                                    :classes="'btn btn-black background-' + this.product +' px-md-4'"
                                    @click="submitForm"
                            > Opslaan
                            </button-loader>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!user.is_profile_completed" class="col-md-8 offset-md-2">
                <alert-ele v-show="messageText" :message="messageText" :status="messageStatus" @dismiss="()=>this.messageStatus = null"/>
                <div class="card profile-form">
                    <div class="card-header pb-3">
                        <template v-if="adminMode">
                            <a :href="goBackUrl" class="mx-1" style="color: #3b3f4b">
                                <span class="fa fa-arrow-left"></span>
                            </a>
                        </template>
                        {{ lang.app.profile.step2_title }}
                        <template v-if="adminMode">
                            <small>(User: {{user.email}})</small>
                        </template>
                    </div>
                    <div class="card-body">
                        <div class="form-group row" v-if="!user.telephone">
                            <label for="telephone"
                                   class="col-md-4 col-form-label text-md-right">{{ lang.app.global.telephone }}</label>
                            <div class="col-md-6">
                                <input
                                        id="telephone" type="text"
                                        class="form-control"
                                        name="telephone"
                                        v-model="form.telephone"
                                        required
                                        autocomplete="none"
                                        :placeholder="lang.app.global.telephone"
                                >
                                <error-ele v-if="formValidationErrors &&
                                             formValidationErrors['telephone']"
                                           :errors="formValidationErrors['telephone']"
                                />
                            </div>

                        </div>

                        <div class="form-group row">
                            <label for="street_name"
                                   class="col-md-4 col-form-label text-md-right">{{ lang.app.profile.street
                                }}</label>
                            <div class="col-md-4">
                                <input
                                        id="street_name" type="text"
                                        class="form-control"
                                        name="street_name"
                                        v-model="form.address.street_name"
                                        required
                                        autocomplete="none"
                                        :placeholder="lang.app.profile.street_name"
                                >
                                <error-ele v-if="formValidationErrors &&
                                             formValidationErrors['address.street_name']"
                                           :errors="formValidationErrors['address.street_name']"
                                />
                            </div>
                            <div class="col-md-2">
                                <input
                                        id="street_number" type="text"
                                        class="form-control"
                                        name="street_number"
                                        v-model="form.address.street_number"
                                        required
                                        autocomplete="none"
                                        :placeholder="lang.app.profile.street_number"
                                        maxlength="16"
                                >
                                <error-ele v-if="formValidationErrors &&

                                            formValidationErrors['address.street_number']"
                                           :errors="formValidationErrors['address.street_number']"
                                />
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="postal_code"
                                   class="col-md-4 col-form-label text-md-right">{{ lang.app.profile.residence }}</label>
                            <div class="col-md-2">
                                <input
                                        id="postal_code" type="text"
                                        class="form-control"
                                        name="postal_code"
                                        v-model="form.address.postal_code"
                                        required
                                        autocomplete="none"
                                        :placeholder="lang.app.profile.postal_code"
                                >
                                <error-ele
                                        v-if="formValidationErrors &&
                                                formValidationErrors['address.postal_code']"
                                        :errors="formValidationErrors['address.postal_code']"
                                />
                            </div>
                            <div class="col-md-4">
                                <input
                                        id="city" type="text"
                                        class="form-control"
                                        name="city"
                                        v-model="form.address.city"
                                        required
                                        autocomplete="none"
                                        :placeholder="lang.app.profile.city"
                                >
                                <error-ele
                                        v-if="formValidationErrors &&
                                                    formValidationErrors['address.city']"
                                        :errors="formValidationErrors['address.city']"/>
                            </div>

                        </div>

                        <div class="form-group row">
                            <label for="country"
                                   class="col-md-4 col-form-label text-md-right">{{ lang.app.profile.country }}</label>
                            <div class="col-md-6">
                                <select
                                        id="country"
                                        class="form-control"
                                        name="country"
                                        required
                                        autocomplete="none"
                                        @change="toggleShowAllCountries"
                                        :placeholder="lang.app.profile.country"
                                >
                                    <option value="">{{ lang.app.profile.select }}</option>
                                    <template v-for="country in countries" v-if="showAllCountries || ['BE', 'NL', form.address.country].indexOf(country.value) > -1">
                                        <option :value="country.value" :selected="form.address.country === country.value">
                                            {{ country.label }}
                                        </option>
                                    </template>
                                    <option value="more" v-if="!showAllCountries">More...</option>

                                </select>
                                <error-ele
                                        v-if="formValidationErrors &&
                                                formValidationErrors['address.country']"
                                        :errors="formValidationErrors['address.country']"/>
                            </div>

                        </div>

                        <div v-if="user.role === 'farmer' && form.farmer">

                            <div class="form-group row">
                                <label for="company_profile"
                                       class="col-md-4 col-form-label text-md-right">{{ lang.app.profile.company_profile }}</label>
                                <div class="col-md-6">
                                    <select
                                            id="company_profile"
                                            class="form-control"
                                            name="company_profile"
                                            v-model="form.farmer.bio_certified"
                                            required
                                            autocomplete="none"
                                            :placeholder="lang.app.profile.company_profile"
                                    >
                                        <!--<option v-bind:value="null">{{ lang.app.profile.select }}</option>-->
                                        <option v-bind:value="true">{{ lang.app.profile.organic }}</option>
                                        <option v-bind:value="false">{{ lang.app.profile.common }}</option>

                                    </select>
                                    <error-ele
                                            v-if="formValidationErrors &&
                                                formValidationErrors['farmer.bio_certified']"
                                            :errors="formValidationErrors['farmer.bio_certified']"/>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="email"
                                       class="col-md-4 col-form-label text-md-right">{{ lang.app.global.company_name
                                    }}</label>
                                <div class="col-md-6">
                                    <input
                                            id="company_name" type="text"
                                            class="form-control"
                                            name="company_name"
                                            v-model="form.farmer.company_name"
                                            required
                                            autocomplete="none"
                                            placeholder="Niet verplicht"
                                    >
                                    <error-ele
                                            v-if="formValidationErrors &&  formValidationErrors['farmer.company_name']"
                                            :errors="formValidationErrors['farmer.company_name']"/>
                                </div>

                            </div>

                            <div class="form-group row" v-if="adminMode">
                                <label for="vat_number"
                                       class="col-md-4 col-form-label text-md-right">{{
                                    lang.app.profile.btw_kvk_vat_number
                                    }}</label>
                                <div class="col-md-6">
                                    <input
                                            id="vat_number" type="text"
                                            class="form-control"
                                            name="vat_number"
                                            v-model="form.farmer.vat_number"
                                            maxlength="14"
                                            :placeholder="(selectedCountry ? lang.app.profile['btw_example_' + selectedCountry.toLowerCase()] : lang.app.profile.btw_kvk_vat_number) + (user.farmer.is_professional ? '' : ' (Niet verplicht)')"
                                    >
                                    <error-ele
                                            v-if="formValidationErrors && formValidationErrors['farmer.vat_number']"
                                            :errors="formValidationErrors['farmer.vat_number']"/>
                                </div>
                            </div>

                        </div>

                        <template v-if="user.farmer && ['NL', 'BE'].indexOf(selectedCountry) !== -1">

                            <div v-if="user.farmer.is_professional && selectedCountry==='NL'">
                                <div class="form-group row">
                                    <label for="ubn_number"
                                           class="col-md-4 col-form-label text-md-right">{{ lang.app.profile.ubn_title
                                        }}</label>
                                    <div class="col-md-6">
                                        <input
                                                id="ubn_number" type="text"
                                                class="form-control"
                                                name="ubn_number"
                                                v-model="form.farmer.ubn_number"
                                                required
                                                :disabled="this.user.farmer.ubn_number && this.user.farmer.ubn_number.trim().length > 0"
                                                autocomplete="none"
                                                :placeholder="lang.app.profile.ubn_number_placeholder"
                                        >
                                        <error-ele
                                                v-if="formValidationErrors &&   formValidationErrors['farmer.ubn_number']"
                                                :errors="formValidationErrors['farmer.ubn_number']"/>
                                    </div>


                                </div>
                            </div>
                            <div v-if="user.farmer.is_professional && selectedCountry==='BE'">
                                <div class="form-group row">
                                    <label for="exploitation_number"
                                           class="col-md-4 col-form-label text-md-right">
                                        {{lang.app.profile.exploitation_number + ' *'}}
                                    </label>
                                    <div class="col-md-6">
                                        <input
                                                id="exploitation_number" type="text"
                                                class="form-control"
                                                name="exploitation_number"
                                                v-model="form.farmer.exploitation_number"
                                                required
                                                :disabled="this.user.farmer.exploitation_number && this.user.farmer.exploitation_number.trim().length > 0"
                                                autocomplete="none"
                                                :placeholder="lang.app.profile.exploitation_number_placeholder"
                                        >
                                        <error-ele
                                                v-if="formValidationErrors &&  formValidationErrors['farmer.exploitation_number']"
                                                :errors="formValidationErrors['farmer.exploitation_number']"/>
                                    </div>
                                </div>
                            </div>
                        </template>

                    </div>

                    <div class="form-group row mb-2">
                        <div class="col-md-6 offset-4">
                            <button-loader
                                    :isLoading="profileButtonLoader"
                                    :disabled="profileButtonLoader"
                                    :classes="'btn btn-black background-' + this.product +' px-md-4'"
                                    @click="submitForm"
                            > {{ lang.app.global.save }}
                            </button-loader>
                        </div>
                    </div>

                    <template v-if="user.role === 'farmer' && user.farmer.is_professional && selectedCountry==='BE'">
                        <div class="row my-4">
                            <div class="col-12 col-md-10 offset-md-1">
                                <span>
                                    {{ '* ' + lang.app.profile.exploitation_number_footnote }}
                                </span>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    export default {

        props: ['product', 'user', 'countries', 'animalTypes', 'adminMode'],

        data() {
            const goBackUrl = route('Admin.User.GetRegister', {
                'user_api_id': this.user.id
            });
            return {
                form: this.getUserForm(),
                profileButtonLoader: false,
                disableSave: false,
                profilePicture: this.user.profile_picture,
                newProfilePicture: null,
                newProfilePictureUrl: null,
                passwordResetButtonLoader: false,
                forgetPasswordForm: {
                    'email': this.user.email,
                    'product': this.product
                },
                showAllCountries: false,
                goBackUrl: goBackUrl
            }
        },

        computed: {
            selectedCountry: function () {
                return this.form.address.country;
            }
        },

        methods: {

            getUserForm() {
                let form = {
                    user_api_id: this.user.id,
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    role: this.user.role,
                    telephone: this.user.telephone,
                    email: this.user.email,
                    address: this.user.address ? this.user.address : {
                        city: "",
                        country: "",
                        street_name: "",
                        street_number: "",
                        postal_code: "",
                    },
                    is_profile_completed: (this.user.is_profile_completed || !this.adminMode),
                };

                if (this.user.role === 'farmer') {
                    form.farmer = {
                        vat_number: this.user.farmer.vat_number || "",
                        company_name: this.user.farmer.company_name || "",
                        ubn_number: this.user.farmer.ubn_number || "",
                        exploitation_number: this.user.farmer.exploitation_number || "",
                        is_professional: this.user.farmer.is_professional || false,
                        // animal_type: this.user.farmer.animal_type || "",
                        bio_certified: this.user.farmer.bio_certified,
                    }
                }

                else if (this.user.role === 'advisor') {
                    form.advisor = {
                        vat_number: this.user.advisor.vat_number || "",
                    }
                }

                return form;
            },

            toggleShowAllCountries(event) {
                if (event.target.value === 'more') {
                    this.showAllCountries = true;
                    event.target.mouse;
                } else {
                    this.form.address.country = event.target.value;
                }
            },

            imageUpload(e) {
                if (this.formError && this.formError.errors) {
                    this.formError.errors.profile_picture = null;
                }
                this.disableSave = false;
                if (e.target.files && e.target.files[0]) {
                    this.newProfilePicture = e.target.files[0];

                    let fileInput = e.target;
                    let fileName = this.newProfilePicture.name;
                    fileInput.nextElementSibling.classList.add('selected');
                    fileInput.nextElementSibling.textContent = fileName;

                    const reader = new FileReader();
                    reader.onloadend = () => {
                        this.newProfilePictureUrl = reader.result;
                    };
                    reader.readAsDataURL(this.newProfilePicture);

                    // Do not allow file size > 1MB
                    if (this.newProfilePicture.size >= 1024 * 1024) {
                        e.preventDefault();
                        if (!this.formError || !this.formError.errors) {
                            this.formError = {'errors': {'profile_picture': ['File size should be < 1MB']}};
                        } else {
                            this.formError = {errors: {...this.formError.errors, ...{'profile_picture': ['File size should be < 1MB']}}};
                        }
                        this.disableSave = true;
                    }
                }
            },

            submitForm() {
                this.profileButtonLoader = true;
                this.formError = null;
                this.messageText = null;
                this.messageStatus = null;

                // profile picture upload
                if (this.newProfilePicture) {
                    const imgData = new FormData();
                    imgData.append('user_api_id', this.user.id);
                    imgData.append('profile_picture', this.newProfilePicture);
                    api.profile
                        .postProfilePicture(imgData)
                        .then((response) => {
                            this.profilePicture = this.newProfilePictureUrl;
                            this.newProfilePicture = null;
                            this.newProfilePictureUrl = null;
                        })
                        .catch((error) => {

                            if (error.response.status === 422) {
                                if (!this.formError || !this.formError.errors) {
                                    this.formError = {'errors': {'profile_picture': ['Could not change profile picture!']}};
                                } else {
                                    this.formError = {errors: {...this.formError.errors, ...{'profile_picture': ['Could not change profile picture!']}}};
                                }
                            }
                        });
                }
                // profile form submit

                let form = _.clone(this.form);
                return api.profile
                    .postUpdate(form)
                    .then(response => {
                        this.profileButtonLoader = false;
                        this.messageText = response.data.message;
                        this.messageStatus = 'success';

                        if (this.user.role === 'farmer') {
                            this.form.farmer.is_professional =
                                response.data.user.farmer.is_professional;
                            this.user.farmer.exploitation_number =
                                response.data.user.farmer.exploitation_number;
                            this.user.farmer.ubn_number =
                                response.data.user.farmer.ubn_number;
                        }

                        this.scrollToTop();

                        if (['farmer', 'advisor'].indexOf(this.user.role) < 0) {
                            return;
                        }

                        if (this.adminMode) {
                            window.location.href = route('Admin.User.GetOrder', {user_api_id: this.user.id});
                        } else if (!this.user.is_profile_completed) {
                            window.location.href = route('Subscription.GetCreateProductSubscription', { locales: locale, product: this.product});
                        }

                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            // this.messageText = lang.validation.error_message;
                            // this.messageStatus = "error";
                            if (error.response && error.response.data.errors) {
                                if (this.formError && this.formError.errors) {
                                    this.formError = {errors: {...this.formError.errors, ...error.response.data.errors}}
                                } else {
                                    this.formError = error.response.data;
                                }
                            }
                            this.scrollToTop();
                        }
                        this.profileButtonLoader = false;
                    });
            },

            passwordReset() {
                this.passwordResetButtonLoader = true;

                return api.resetPassword
                    .postForgotPassword(this.forgetPasswordForm)
                    .then(response => {
                        this.passwordResetButtonLoader = false;
                        this.formError = null;
                        this.messageText = response.data.message;
                        this.messageStatus = 'success';
                        setTimeout(() => {
                            window.location.href = route('Auth.GetLogout', {locales: locale, product: this.product});
                        }, 2000);
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.messageText = lang.validation.error_message;
                            this.messageStatus = "error";
                            this.scrollToTop();
                        }
                        this.passwordResetButtonLoader = false;
                    });
            }

        },


    }
</script>



// WEBPACK FOOTER //
// resources/js/components/user/Profile.vue